<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setLang } from '@/libs/util.lang'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  components: {
  },
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created () {
    this.i18nHandle(this.$i18n.locale)
  },
  methods: {
    ...mapActions('admin/locales',['load']),
    // eslint-disable-next-line no-unused-vars
    i18nHandle (val, oldVal) {
      setLang(val)
      document.querySelector('html').setAttribute('lang', val)
    }
  }
}
</script>
<style lang="scss">
@import '~@/assets/style/public-class.scss';
</style>
